<template>
  <div>

    <!-- 面包屑导航 -->
<!--    <el-page-header size="mini" @back="back" style="padding: 10px 0;" :content="title">-->
<!--    </el-page-header>-->
    <!-- 卡片 -->
    <el-card class="box-card">

      <el-form
          :inline="false"
          :model="addForm"
          ref="addForm"
          :rules="rules"
          autocomplete="on"
          size="mini"
          label-width="80px">

        <el-row :gutter="24">
          <el-col :span="6">
            <el-link type="primary" @click="back"><i class="el-icon-back"></i> 返回</el-link>
             |
<!--            <el-link href="/Welcome">首页</el-link>-->
<!--            >-->
<!--            <el-link type="primary" href="/extrasFeeList">费用列表</el-link>-->
<!--            > -->
            {{ title }}
          </el-col>
          <el-col :span="6">
            <el-form-item label="选择个人" label-width="80px" size="small" required>
              <el-select v-model="addForm.car_username"placeholder="请选择个人" @change="changeVal" disabled>
                <el-option
                    v-for="item in carUserName"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="选择车辆" size="small">
              <el-select v-model="addForm.car_id" filterable clearable placeholder="请选择车牌">
                <el-option
                    v-for="item in carData"
                    :label="item.plate_number"
                    :value="item.id"
                    :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button style="margin-bottom: 10px" size="small" type="primary" @click="setFeeData">
              添加费用明细
            </el-button>
          </el-col>


        </el-row>
        <el-row :gutter="24" v-if="addForm.id">
          <el-col :span="24">
            <el-descriptions title="各项费用统计" direction="vertical" :column="7" border size="mini">
              <el-descriptions-item label="车辆台次">5</el-descriptions-item>
              <el-descriptions-item label="统计项目">10 个</el-descriptions-item>
              <el-descriptions-item label="应收">150000</el-descriptions-item>
              <el-descriptions-item label="成本">100000</el-descriptions-item>
              <el-descriptions-item label="利润">100000</el-descriptions-item>
              <el-descriptions-item label="已收">100000</el-descriptions-item>
              <el-descriptions-item label="未收">100000</el-descriptions-item>
            </el-descriptions>
            <br />
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24" align="left">

            <el-table
                :data="feeDataList"
                stripe border
                :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
                height="450px"
                size="mini"
            >
              <el-table-column label="操作" align='center' width="60px">
                <template slot-scope="scope" align="center">
                  <el-button @click.native.prevent="deleteItem(scope.$index, scope.row)" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                </template>
              </el-table-column>

              <el-table-column label="各项费用详情" align="center">
                <template slot-scope="scope">
                  <div>
                    <el-descriptions title="" direction="vertical" :column="9" size="mini" border>

                      <el-descriptions-item label="个人">
                        {{ scope.row.car_username }}
                      </el-descriptions-item>

                      <el-descriptions-item label="车牌号">
                        鲁Q620KR
                      </el-descriptions-item>
                      <el-descriptions-item label="所属人">
                        山东明旭物流有限公司
                      </el-descriptions-item>
                      <el-descriptions-item label="车架号">
                        LC1AMMBE2K0014494
                      </el-descriptions-item>

                      <el-descriptions-item label="应收">
                        <el-input v-model="scope.row.ysfee" ></el-input>
                      </el-descriptions-item>
                      <el-descriptions-item label="成本">
                        <el-input v-model="scope.row.cbfee" ></el-input>
                      </el-descriptions-item>
                      <el-descriptions-item label="利润">
                        <el-input v-model="scope.row.lrfee" ></el-input>
                      </el-descriptions-item>
                      <el-descriptions-item label="已收">
                        <el-input v-model="scope.row.yishoufee" ></el-input>
                      </el-descriptions-item>
                      <el-descriptions-item label="未收">
                        <el-input v-model="scope.row.wsfee" ></el-input>
                      </el-descriptions-item>
<!--                      <el-descriptions-item label="操作">-->
<!--                        <div class="centerText">-->
<!--                          <el-button type="primary" size="mini" @click="innerVisible = true" title="添加还款记录"><i class="el-icon-circle-plus-outline"></i>还款记录</el-button>-->
<!--                        </div>-->
<!--                      </el-descriptions-item>-->
                      <el-descriptions-item label="费用类型">
                        <el-select v-model="scope.row.fee_type" clearable placeholder="请选择费用类型" filterable allow-create>
                          <el-option
                              v-for="item in feeTypeList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                          </el-option>
                        </el-select>
                      </el-descriptions-item>
                      <el-descriptions-item label="费用名称">
                        <el-input v-model="scope.row.name" ></el-input>
                      </el-descriptions-item>
                      <el-descriptions-item label="经办角色">
                        <el-select v-model="scope.row.jbrTypeId" clearable placeholder="请选择经办人角色" filterable allow-create>
                          <el-option
                              v-for="item in jbrTypeList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                          </el-option>
                        </el-select>
                      </el-descriptions-item>
                      <el-descriptions-item label="经办姓名">
                        <el-select v-model="scope.row.jbrxmTypeId" clearable placeholder="请选择经办人姓名" filterable allow-create>
                          <el-option
                              v-for="item in jbrxmTypeList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                          </el-option>
                        </el-select>
                      </el-descriptions-item>
                      <el-descriptions-item label="备注">
                        <el-input type="textarea" v-model="scope.row.remark" :autosize="{ minRows: 2, maxRows: 3}"></el-input>
                      </el-descriptions-item>

                    </el-descriptions>
                    <div v-if="scope.row.repaymentList.length > 0">
                      <el-table
                          :data="scope.row.repaymentList"
                          stripe border height="300px"
                          show-summary size="mini"
                          :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
                      >

                        <el-table-column
                            label="操作"
                            :show-overflow-tooltip='true'
                            width="60px" align="center"
                        >
                          <el-button @click.native.prevent="deleteItem(scope.$index, scope.row)" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                        </el-table-column>
                        <el-table-column
                            label="还款时间"
                            :show-overflow-tooltip='true'
                            width="150px"
                        >
                          2024-01-25 15:26:30
                        </el-table-column>
                        <el-table-column
                            prop="cbfee"
                            label="还款金额"
                            :show-overflow-tooltip='true'
                        >

                        </el-table-column>
                        <el-table-column
                            label="付款人"
                            :show-overflow-tooltip='true'
                        >
                          测试付款人
                        </el-table-column>
                        <el-table-column
                            label="付款帐号"
                            :show-overflow-tooltip='true'
                        >
                          34534534534534535454354
                        </el-table-column>
                        <el-table-column
                            label="付款银行"
                            :show-overflow-tooltip='true'
                        >
                          建设银行
                        </el-table-column>

                        <el-table-column
                            label="收款人"
                            :show-overflow-tooltip='true'
                        >
                          测试收款人
                        </el-table-column>
                        <el-table-column
                            label="收款帐号"
                            :show-overflow-tooltip='true'
                        >
                          2222222345344234234
                        </el-table-column>
                        <el-table-column
                            label="付款银行"
                            :show-overflow-tooltip='true'
                        >
                          山东兰山建设支行
                        </el-table-column>
                        <el-table-column
                            label="附件"
                            :show-overflow-tooltip='true'
                        >
                          <viewer >
                        <span>
                          <img src="https://zkycyd.oss-cn-beijing.aliyuncs.com/md/bfbz/6/0376702412b9b8ff792349685a3d42e81c97d632.jpg" min-width="20" height="20"/>
                        </span>
                          </viewer>
                        </el-table-column>
                      </el-table>
                    </div>

                  </div>


                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>

      </el-form>
      <el-row :gutter="24" class="centerButton">
        <el-col :span="24">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('addForm')">确 定</el-button>
        </el-col>
      </el-row>
    </el-card>
    <!-- 全局遮罩 图片上传 -->
    <el-dialog :visible.sync="dialogVisible" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
      <div class="loading-overlay">
        <div class="loading-spinner" style="font-size:30px;font-weight: bold">
          <i class="el-icon-upload"></i>
          图片上传ing
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'     //日期时间转换
import imgCompressUtil from "../../utils/imgCompressUtil";
import carListTemp from "../common/carlistTemp.vue";


export default {
  name: "extrasFeeEdit",
  components: {carListTemp},
  data() {
    return {
      dialogVisible: false,
      overlayClass: 'loading-overlay', // 遮罩元素的类名
      addForm:{
        id:'',
        car_info:'',
        car_id:'',
        plate_number:'',
        allPerson:'',
        vin:'',
        car_username:'',
      },

      rules: {
        // plate_number: [{ required: true, message: '请输入号牌号码', trigger: 'blur' }],
        // allPerson: [{ required: true, message: '请输入所有人', trigger: 'blur' }],
        // shop_id: [{ required: true, message: '请选择运输公司', trigger: 'blur' }],
        // vin: [{ required: true, message: '请输入车辆识别代号', trigger: 'blur' }],
        car_username: [{ required: true, message: '请输入个人', trigger: 'blur' }],
      },
      title: '费用列表 - 新增',
      feeDataList:[
        {
          'name':'费用名称',
          'fee_type':'1',
          'jbr_type':'1',
          'jbrxm_type':'1',
          'ysfee':'1666.88',
          'cbfee':'1000.88',
          'lrfee':'666.00',
          'yishoufee':'666.88',
          'wsfee':'1000.00',
          'remark':'备注',
          'car_id':'',
          'allPerson':'',
          'plate_number':'',
          'vin':'',
          'car_username':'李四',
          'repaymentList':[
            {
              'name': '费用名称',
              'fee_type': '1',
              'cbfee': '10009.89',
            },
            {
              'name': '费用名称',
              'fee_type': '1',
              'cbfee': '10009.89',
            },
          ]
        },
        {
          'name':'费用名称',
          'fee_type':'1',
          'jbr_type':'1',
          'jbrxm_type':'1',
          'ysfee':'1666.88',
          'cbfee':'1000.88',
          'lrfee':'666.00',
          'yishoufee':'666.88',
          'wsfee':'1000.00',
          'remark':'备注',
          'car_id':'',
          'allPerson':'',
          'plate_number':'',
          'vin':'',
          'car_username':'李四',
          'repaymentList':[
            {
              'name': '费用名称',
              'fee_type': '1',
              'cbfee': '10009.89',
            },
            {
              'name': '费用名称',
              'fee_type': '1',
              'cbfee': '10009.89',
            },
          ]
        },
        {
          'name':'费用名称',
          'fee_type':'1',
          'jbr_type':'1',
          'jbrxm_type':'1',
          'ysfee':'1666.88',
          'cbfee':'1000.88',
          'lrfee':'666.00',
          'yishoufee':'666.88',
          'wsfee':'1000.00',
          'remark':'备注',
          'car_id':'',
          'allPerson':'',
          'plate_number':'',
          'vin':'',
          'car_username':'李四',
          'repaymentList':[
            {
              'name': '费用名称',
              'fee_type': '1',
              'cbfee': '10009.89',
            },
            {
              'name': '费用名称',
              'fee_type': '1',
              'cbfee': '10009.89',
            },
          ]
        }
      ],
      feeTypeList:[
        {
          value: '1',
          label: '车辆年审费用'
        },
        {
          value: '2',
          label: '车辆管理费'
        },
        {
          value: '3',
          label: '营运证年审'
        },
        {
          value: '4',
          label: '驾驶证年审'
        },
        {
          value: '5',
          label: '二级维护'
        },
        {
          value: '6',
          label: '从业资格证年审'
        },
        {
          value: '7',
          label: '车辆等级评定费'
        },
        {
          value: '8',
          label: '其他费用'
        },
      ],
      jbrTypeList:[
        {
          value: '1',
          label: '超管'
        },
        {
          value: '2',
          label: '财务'
        },
        {
          value: '3',
          label: '内勤'
        }
      ],
      jbrxmTypeList:[
        {
          value: '1',
          label: '张珊'
        },
        {
          value: '2',
          label: '李四'
        }
      ],
      carUserName:[
        {
          value: '1',
          label: '张珊'
        },
        {
          value: '2',
          label: '李四'
        }
      ],
      innerVisible: false,
      carData:[], //车辆列表
    };
  },
  created() {
    this.addForm.car_username = '李四';
    this.getCarData();
    var id = this.$route.query.id;
    // console.log('费用',id);
    if(id){
      this.title = '费用列表 - 编辑'
      this.addForm.id=id;
      this.getOne();
    }
  },
  mounted() {},
  filters: {

    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },

  },
  methods: {
    back(){
      this.$router.back();
    },
    //更新经办人姓名
    changeVal(val){
      // console.log('changeVal',val);
      // 判断val是否为数字
      if (typeof val === 'number') {
        console.log('val 是数字',val);

      } else {
        // 判断val是否为汉字
        if (/^[\u4e00-\u9fa5]+$/.test(val)) {
          console.log('val 是汉字',val);

        } else {
          console.log('val 不是数字也不是汉字',val);

        }
      }
    },
    // 新增
    setFeeData() {
      let item = {
        'name':'',
        'fee_type':'',
        'jbr_type':'',
        'jbrxm_type':'',
        'ysfee':'',
        'cbfee':'',
        'lrfee':'',
        'yishoufee':'',
        'wsfee':'',
        'remark':'',
        'car_id':'',
        'allPerson':'',
        'plate_number':'',
        'vin':'',
        'car_username':'',
        'repaymentList':[]
      };
      if(this.addForm.car_id){
        const car_info = this.carData.find(item => item.id === this.addForm.car_id);
        // console.log('car_info',car_info);
        item.car_id = car_info.id;
        item.allPerson = car_info.allPerson;
        item.plate_number = car_info.plate_number;
        item.vin = car_info.vin;
      }

      if(this.addForm.car_username){
        item.car_username = this.addForm.car_username;
      }else{
        this.$message.error('请先选择个人/或者填写');return false;
      }
       console.log('setFeeData-addForm',this.addForm);
       console.log('setFeeData-item',item);
      this.feeDataList.push(item);
    },
    //删除数据
    deleteItem(index, row) {
      this.feeDataList.splice(index, 1);
      if(row.id)
        this.del(row)
      //删除接口
    },
    setcarInfo(value){
      this.$set(this.addForm,'allPerson' , value.allPerson) //不用set 的形式，页面数据不更新
      console.log('setcarInfo-value',value);
      if(value){
        this.addForm.plate_number = value.plate_number
        this.addForm.car_id = value.car_id
        this.addForm.vin = value.vin
        this.addForm.model = value.model
        this.addForm.issue_date = value.issue_date
        this.addForm.register_date = value.register_date
      }else{
        this.addForm = {};
      }

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            feeDataList:this.feeDataList,
          }
          if(this.id) param.id = this.form.id
          this.$axios.saveOtherFee(param).then(res =>{
            if(res.code == 200){
              this.DataList();
              this.$message.success(res.msg);
              this.dialogFormVisible = false;
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      })
    },
    resetForm(){
      this.addForm = {
        id:'',
        car_id:'',
        plate_number:'',
        allPerson:'',
        vin:'',
        car_username:'',
      };
    },
    getCarData() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.getCarList(param).then(res=>{
        if(res.code == 200){
          //console.log(res.data.data);
          this.carData = res.data.data
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },

  },
};
</script>
<style scoped>
.centerButton{
  margin-top:20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/fee/extrasFeeEdit.vue